export const environment = {
  production: false,
  baseUrl: 'https://e2-api.botpenguin.com/',
  decryptKey: 'vm@botpenguin2025',
  cdnUrl: 'https://dev-botpenguin.s3.us-east-2.amazonaws.com/cdn',
  rootAgencyId: '614c81464774d71b1fad621f',
  devHosting: {
    devToken: 'eyJhbGciOiJSUzUxMiIsInR5cCI6IkpXVCJ9.eyJuYW1lIjoiU3VyYWogS3VtYXIgUmVsaW5ucyIsIl9wYXJlbnQiOiI2MTRjODE0NjQ3NzRkNzFiMWZhZDYyMWYiLCJfaWQiOiI2NGI2Yjc5OWZmYjgyNGFjOTJmYjVhZjkiLCJ0eXBlIjoiQ1VTVE9NRVIiLCJyb2xlIjoiNWZhOTEzYjA5ZjcwNjg0YWYwMDRkYjEzIiwicm9vdFVzZXJSb2xlSWQiOiI1ZmE5MTNhZDlmNzA2ODRhZjAwNGRiMTIiLCJpbXBlcnNvbmF0ZSI6dHJ1ZSwicGVybWlzc2lvbiI6IkFHRU5DWSIsImlhdCI6MTc1Mzc5NzM5MSwiZXhwIjoxNzU2Mzg5MzkxLCJhdWQiOiJhcHAuYm90cGVuZ3Vpbi5jb20iLCJpc3MiOiJSZWxpbm5zIFRlY2hub2xvZ2llcyBQcml2YXRlIExpbWl0ZWQiLCJzdWIiOiJzdXJhakByZWxpbm5zLmNvbSIsImp0aSI6IjczODNjNTMwLTlhMDEtNGRiYS1hMmZmLWM5NjdkZjUzNzUyOCJ9.RFYGbkNKsHFWbgpEb46_4UzlYOOiY2EUoJUCc6LaSHOQUx_Bt1shLpucAO8RfCbGMA03eJ6Xh3wKl_ybG1PRiT90vaiXBW37C5QtN4x5CANN48esofOIM9cpJkKWyf3cmigNuK5QM34R3Z45GwMGsEiY_IiXCWyUiKIwVcfYGMFDWUq6-E6kkQyMvgPA9mDtwX798yFGMiuVZEFPqeyOtBzNvl8hsjuJk2NiFh214DvZjr6g_ED7ItBWdcc1Su4WHWad-XSZfJ7_NrjDDrAluWegzgvIsNEXoW6_UiuRO9914H31LIjB08VcIjwBoWbwh6srPXcHX-OrOvpSWhEJIA',
    customerId: '64b6b799ffb824ac92fb5af9',
    agencyId: '614c81464774d71b1fad621f',
    language: 'en',
    brand: 'BotPenguin'
  },
  cdnExpressUrl: 'https://cdn.express-chat.com',
  landingPage: 'https://e2-page.botpenguin.com/',
  embeddedBot: 'https://messenger.botpenguin.com/',
  botScript: 'website-bot.js',
  HELP_URL: 'https://help.botpenguin.com/botpenguin-resource-centre'
};